const safetyCheckQuestions = {
    'Under the Bonnet': [
        'Auxiliary Drive Belts',
        'Cleanliness / Fluid Contamination',
        'Fuel Pipes & Connections',
        'Brake Pipes (Visible Sections)',
        'Coolant Hoses',
        'Battery Condition & Security',
        'Wiring (Visible Inspection)',
        'Coolant Level & Anti-Freeze',
        'Windscreen Washer Fluid Level',
        'Power Steering Fluid (If Applicable)',
        'Brake Fluid Level',
        'Engine Oil Level',
        'Bonnet Catch Operation'
    ],

    'Under the Vehicle': [
        'Coolant Leaks',
        'Engine Oil Leaks',
        'Engine Oil Filter Condition',
        'Clutch Hydraulic System (Manual Only)',
        'Manual Transmission Leaks (If Applicable)',
        'Automatic Transmission Leaks (If Applicable)',
        'Rear Axle Condition',
        'Steering Joints',
        'Steering Rack / Steering Box',
        'Steering Column Couplings',
        'Suspension Joints & Gaiters',
        'Driveshaft Joints & Gaiters',
        'Shock Absorbers & Mountings',
        'Exhaust System & Mountings'
    ],

    'Braking System': [
        'Front Brake Pads (Wear/Condition)',
        'Front Brake Discs (Wear/Condition)',
        'Front Brake Calipers',
        'Parking Brake Travel & Operation',
        'Footbrake Pedal Travel/Feel',
        'Rear Brake Pads (Wear/Condition)',
        'Rear Brake Discs (Wear/Condition)',
        'Rear Brake Calipers',
        'Brake Drums/Shoes/Cylinders (If Applicable)',
        'Brake Hydraulic System'
    ],

    'Wheels & Tools': [
        'Road Wheels Condition',
        'Spare Wheel Present (If Applicable)',
        'Locking Wheel Nut Present',
        'Wheel Nuts Secure & Torqued',
        'Tool Kit Present',
        'Tyre Inflation/Repair Kit (If Applicable)'
    ],

    'Tyres': [
        'Nearside Front Tyre',
        'Nearside Rear Tyre',
        'Offside Front Tyre',
        'Offside Rear Tyre'
    ],

    'Inside the Vehicle': [
        'Diagnostic Fault Codes',
        'Dashboard Instruments & Warning Lights',
        'Switches & Controls Operation',
        'Horn Operation',
        'Interior Lamps',
        'Seat Belt Condition',
        'Seat Belt Operation',
        'Seat Belt Fasteners',
        'Heating / Blower / Ventilation',
        'Seat Operation & Security',
        'Electric Window Operation (If Applicable)',
        'Electric Mirror Operation (If Applicable)',
        'Door Locks',
        'Door Handles',
        'Central Locking Operation (If Applicable)'
    ],

    'Outside the Vehicle': [
        'Front Wiper Blades',
        'Front Washer Operation',
        'Rear Wiper Blades (If Applicable)',
        'Rear Washer Operation (If Applicable)',
        'Headlight Wash/Wipe (If Applicable)',
        'Door Handles',
        'Door Hinges',
        'Glass Condition',
        'Windscreen Condition',
        'Aerial (If Applicable)',
        'Direction Indicators',
        'Hazard Warning Lights',
        'Side Lights',
        'Headlights - Dipped Beam',
        'Headlights - Full Beam',
        'Front Fog Lights (If Applicable)',
        'Rear Fog Lights (If Applicable)',
        'Reverse Lights',
        'Number Plate Lights',
        'Light Cluster Condition'
    ],

    'Road Test': [
        'Cold Start Performance',
        'General Road Test Performance',
        'Fuel Gauge Operation',
        'Temperature Gauge Operation',
        'Rev Counter',
        'Speedometer',
        'Odometer',
        'Clutch Operation (If Applicable)',
        'Gearbox Operation',
        'Brake Operation',
        'Cooling Fan Operation',
        'Hot Start Performance'
    ]
}


export default safetyCheckQuestions